export function stableSorted<T>(collection: readonly T[], comparator: (a: T, b: T) => number): T[] {
  return collection
    .map((item, index) => ({ item, index }))
    .sort(({ item: a, index: indexA }, { item: b, index: indexB }) =>
      comparator(a, b) || indexA - indexB
    )
    .map(indexedItem => indexedItem.item)
}
